import styled, { css } from 'styled-components';
import Button from '@material-ui/core/Button';

export type ButtonTypeStyleProps = 'PRIMARY' | 'SECONDARY'

type Props = {
  typeButton: ButtonTypeStyleProps;
}

export const StyledContainer = styled(Button)<Props>`
  border: none;
  border-radius: 0.6rem;
  height: 3.5rem;
  width: 18rem;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  background: ${(props) => props.theme.colors.primary} !important;
  color: ${(props) => props.theme.colors.white} !important;
  position: relative;
  transition: 0.3s;
  padding: 0 2rem;
  
  font-size: 1.2rem;
  text-transform: capitalize;
  font-weight: 700;

  .MuiButton-label {
    font-size: 1.2rem;
    font-weight: normal;
  }

  svg {
    margin-right: 0.5rem;
  }

  &:hover,
  &:focus {
    background: ${(props) => props.theme.colors.primary} !important;
    top: 0.2rem;
    color: ${(props) => props.theme.colors.white};
    outline: none;
    text-decoration:none;
  }

  ${(props) => props.typeButton === 'SECONDARY' && css`
    background: ${props.theme.colors.grey} !important;
    color: ${props.theme.colors.white} !important;
    
    &:hover,
    &:focus {
      background: ${props.theme.colors.grey} !important;
      color: ${props.theme.colors.white} !important;
    }
  `}
`;
